// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c46ebd8d","239":"3dcc16ee","455":"29faac6e"}[chunkId] + ".chunk.js";
};